<template>
	<div>
		<div class="filter-inline-panel cle">
			<div class="filter-panel"></div>
          <div class="list-opinion fr">
	        <el-button type="primary" size="mini" @click="$router.back(-1)">{{$t('index.return')}}</el-button>
            <!-- <el-button type="primary" size="mini" @click="add()"  v-if="hasBtn('sub_add')">{{$t('index.add')}}</el-button> -->
          </div>
        </div>
		<el-tabs v-model="activeName" type="border-card">
			<el-tab-pane :label="$t('virtual.course')" data-name="课程列表" name="course">
				<course :course_type="query.course_type" :type="activeName" :course_id="query.id"></course>
			</el-tab-pane>
			<el-tab-pane :label="$t('virtual.student_list')" data-name="学生列表" name="student_list">
				<student :course_type="query.course_type" :type="activeName" :course_id="query.id"></student>
			</el-tab-pane>
			<el-tab-pane :label="$t('virtual.teacher_leave')" data-name="老师请假" name="teacher_leave">
				<leave :course_type="query.course_type" :type="activeName" user_type="teacher" :course_id="query.id"></leave>
			</el-tab-pane>
			<el-tab-pane :label="$t('virtual.student_leave')" data-name="学生请假" name="student_leave">
				<leave :course_type="query.course_type" :type="activeName" user_type="user" :course_id="query.id" ></leave>
			</el-tab-pane>
			<el-tab-pane :label="$t('virtual.comment')" data-name="查看点评" name="comment">
				<evaluate :course_type="query.course_type" :type="activeName" :course_id="query.id"></evaluate>
			</el-tab-pane>
			<el-tab-pane :label="$t('virtual.feedback')" data-name="意见反馈" name="feedback">
				<feedback :course_type="query.course_type" :type="activeName" :course_id="query.id"></feedback>
			</el-tab-pane>
			<el-tab-pane :label="$t('virtual.private')" data-name="公/私信" name="private">
				<virtualmaillist :course_type="query.course_type" :type="activeName" :course_id="query.id"></virtualmaillist>
			</el-tab-pane>
			<el-tab-pane :label="$t('virtual.chat')" data-name="师生交流" name="chat">
				<communication :course_type="query.course_type" :type="activeName" :course_id="query.id"></communication>
			</el-tab-pane>
		</el-tabs>
	</div>
</template>
<script>
import leave from '../../components/leave.vue'
import feedback from '../../components/feedback.vue'
import evaluate from '../../components/evaluate.vue'
import communication from '../../components/communication.vue'
import virtualmaillist from '../../components/virtualmaillist.vue'
import student from '../../components/student.vue'
import course from '../../components/course.vue'
export default {
	name:'no_cache',
	components: {
		leave,
		evaluate,
		communication,
		virtualmaillist,
		feedback,
		student,
		course
	},
	data() {
		return {
			activeName:'',
			query:{},
		}
	},
	// 初始事件
	mounted: function () {
		sessionStorage.setItem("virtual_index",true);
		this.activeName=this.$route.query.table||'course';
		this.query=this.$route.query;
	},
	// 事件
	methods: {
	},
	// 过滤器
	filters: {

	}
}
</script>


// WEBPACK FOOTER //
// src/views/virtual/index.vue